export function parseTextChipTokens(raw: string): string[] {
  return raw
    .split(/[,;\n]+/)
    .map((token) => token.trim())
    .filter((token) => token.length > 0);
}

export function mergeTextChips(existing: readonly string[], incoming: readonly string[]): string[] {
  const out = [...existing];
  const seen = new Set(existing.map((value) => value.toLowerCase()));
  for (const token of incoming) {
    const trimmed = token.trim();
    if (trimmed === "") {
      continue;
    }
    const key = trimmed.toLowerCase();
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    out.push(trimmed);
  }
  return out;
}

export function commitDraftTextChip(draft: string): { chip: string | null; remainingDraft: string } {
  const trimmed = draft.trim();
  if (trimmed === "") {
    return { chip: null, remainingDraft: "" };
  }
  return { chip: trimmed, remainingDraft: "" };
}
